export default {
  tokenKeyName: 'auth_token',
  profileKeyName: 'pb_identities',

  guestRedirectPath: '/auth/login',
  memberRedirectPath: '/',

  jwtRefreshEnabled: process.env.VUE_APP_JWT_REFRESH_ENABLED !== 'false'
}
